import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ScreenLockService } from '../services/screen-lock.service';

/** Redirects to lock screen when the user has manually locked the session. */
export const screenLockGuard: CanActivateFn = () => {
  const screenLock = inject(ScreenLockService);
  const router = inject(Router);

  if (!screenLock.isLocked()) {
    return true;
  }

  return router.createUrlTree(['/auth/lock-screen']);
};
